// Formatadores brasileiros
export const fmtBRL = (v, opts = {}) => {
  const n = Number(v || 0);
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: opts.minimumFractionDigits ?? 2,
    maximumFractionDigits: opts.maximumFractionDigits ?? 2,
  }).format(n);
};

export const fmtBRLCompact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1_000_000) {
    return 'R$ ' + (n / 1_000_000).toFixed(2).replace('.', ',') + 'M';
  }
  if (Math.abs(n) >= 1_000) {
    return 'R$ ' + (n / 1_000).toFixed(1).replace('.', ',') + 'k';
  }
  return fmtBRL(n);
};

export const fmtNumber = (v, decimals = 2) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(v || 0));
};

export const fmtPct = (v, decimals = 2) => {
  const n = Number(v || 0);
  return n.toFixed(decimals).replace('.', ',') + '%';
};

export const fmtDate = (iso) => {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  } catch {
    return iso;
  }
};

export const competenceLabel = (yyyymm) => {
  if (!yyyymm) return '';
  const [y, m] = yyyymm.split('-');
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
  ];
  return `${months[parseInt(m, 10) - 1]} / ${y}`;
};

export const competenceShort = (yyyymm) => {
  if (!yyyymm) return '';
  const [y, m] = yyyymm.split('-');
  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  return `${months[parseInt(m, 10) - 1]}/${y.slice(-2)}`;
};

export const todayISO = () => {
  return new Date().toISOString().slice(0, 10);
};

export const currentCompetence = () => {
  return new Date().toISOString().slice(0, 7);
};

export const isProfit = (v) => Number(v || 0) >= 0;
